module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Acknowledgments"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Acknowledgments")])])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("It is with humility and gratitude to those who have gone ahead that we thank them for\n        their legacy. From the nameless slaves and cooks who tended crops and stoked fires, to those\n        who wrote down what they cooked and what they ate, we thank you. Recipe collections begun by\n        Martha Washington (1749), Thomas Jefferson (1780), Mary Randolph (1824), Sarah Rutledge\n        (1864), Mrs. A. P. Hill (1867), and Mrs. S. R. Dull (1928) eventually found their way into\n        print, providing hundreds of “receipts” of inspiration. Community cookbooks published\n        throughout the South are a source of pride here, and for good reason. Honest food is found\n        between their pages. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("We look to our contemporaries in the field and thank them for keeping the South on the\n        minds of cooks across the United States: John Egerton, John Folse, Damon Lee Fowler, Rebecca\n        Lang, Dorie Sanders, David Shields, Virginia Willis, and others. We miss the nearness of\n        Edna Lewis but know this collection would make her smile, just knowing more people will\n        learn the true techniques of Southern cooking. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Our primary debt, however, is to those who have helped so generously along the way,\n        starting with Kate Almand and Grace Reeves at Nathalie’s Restaurant; those from Rich’s\n        cooking school, starting with Charles Gandy and Elise Griffin and ending ten years later\n        with Carol Smaglinski and Margaret-Anne Surber; those of the first television crew, starting\n        with Forsythia Chang, Anne Galbraith, and Gena Berry, then Ray Overton, and ending fifteen\n        years later with Virginia Willis and Mary Moore; and those who worked so assiduously on this\n        book, starting with Deidre Schipani for her wisdom and ending with intern Mary Katherine\n        Wyeth, who, too, quickly became a diligent cook and recipe tester. We have credited many of\n        their recipes here. Beth Price was our ballast when we felt we were sinking, always there to\n        read another round of edited recipes, as well as devise and coordinate our recipe testing by\n        outside testers. Our loyal friends and fans have helped us write a better book, especially\n        our battery of a dozen proofreaders, including Carol Kay, Sarah Gaede, Sally Young, and Pat\n        Royalty. We wish we could name you all. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("We are grateful as well for our patient families and friends, who during the last few\n        weeks of our editing, got nothing to eat without fixing it themselves and put up with our\n        bleary eyes and short tempers. That said, for five years they reaped the benefits of eating\n        well. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("We could not have done this book without those at Gibbs Smith publishing: Christopher\n        Robbins, for pushing us to do it, and most importantly, our hard-working and loyal editor,\n        Madge Baird, and production editor/designer, Melissa Dymock. And right up to the bitter end,\n        our talented and supremely dedicated photographer, Rick McKee, who was there to shoot a dish\n        or ingredient on a moment’s notice. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("It is difficult to close the acknowledgements, fearing we have omitted someone who should\n        appear between these covers. Whoever you may be, please accept our appreciation for your\n        contribution to this tome, and our sincere apology for our oversight. ")])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of the authors."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e70",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of the authors.",
      "src": "images/RCM_5314.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258aac0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 66
// module chunks = 0